import { Icon } from '@iconify/react';
import homeFill from '@iconify/icons-eva/home-fill';
import fileFill from '@iconify/icons-eva/file-fill';
import roundGrain from '@iconify/icons-ic/round-grain';
import bookOpenFill from '@iconify/icons-eva/book-open-fill';
import { NavConfig } from '../../@types/nav-config';
// routes
import {
  PATH_AUTH,
  PATH_DOCS,
  PATH_PAGE,
  PATH_DASHBOARD,
  PATH_WATCHLIST
} from '../../routes/paths';

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 22,
  height: 22
};

const menuConfig: NavConfig = {
  default: [
    // {
    //   title: 'Blog',
    //   icon: <Icon icon={homeFill} {...ICON_SIZE} />,
    //   path: 'https://medium.com/@tradingtownofcmu',
    //   isAuthenticated: undefined
    // },
    // {
    //   title: 'Watchlist',
    //   icon: <Icon icon={homeFill} {...ICON_SIZE} />,
    //   path: PATH_WATCHLIST.root,
    //   isAuthenticated: undefined
    // },
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      screenName: 'InsiderTrading',
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'InsiderTrading'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'InsiderTrading'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      signInToolTip: false,
      isAuthenticated: undefined,
      menuItemOnClick: () => {}
    },
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {}
    },
    // {
    //   title: 'Profile',
    //   icon: <Icon icon={homeFill} {...ICON_SIZE} />,
    //   path: PATH_DASHBOARD.root,
    //   isAuthenticated: true
    // },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      menuItemOnClick: () => {}
    }
  ],
  '/terms': [],
  '/policy': [],
  '/insidertrading': [
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      screenName: 'InsiderTrading',
      menuItemOnClick: () => {}
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      screenName: 'InsiderTrading',
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'InsiderTrading'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'InsiderTrading'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      signInToolTip: false,
      isAuthenticated: undefined,
      menuItemOnClick: () => {}
    },
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      screenName: 'InsiderTrading',
      menuItemOnClick: () => {}
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      screenName: 'InsiderTrading',
      menuItemOnClick: () => {}
    }
  ],
  '/docs': [
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'API Docs'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'API Docs'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'API Docs'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'API Docs'
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/docs',
      menuItemOnClick: () => {},
      screenName: 'API Docs'
    }
  ],
  '/daily-top-insider-buys': [
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'DailyTopInsiderBuys'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'DailyTopInsiderBuys'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'DailyTopInsiderBuys'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      isAuthenticated: false,
      signInToolTip: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'DailyTopInsiderBuys'
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      menuItemOnClick: () => {},
      screenName: 'DailyTopInsiderBuys'
    }
  ],
  '/daily-top-insider-buy/:date': [
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'DailyTopInsiderBuyByDate'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'DailyTopInsiderBuyByDate'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'DailyTopInsiderBuyByDate'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      signInToolTip: false,
      isAuthenticated: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'DailyTopInsiderBuyByDate'
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      menuItemOnClick: () => {},
      screenName: 'DailyTopInsiderBuyByDate'
    }
  ],
  '/weekly-top-insider-buys': [
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuys'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'WeeklyTopInsiderBuys'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'WeeklyTopInsiderBuys'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      signInToolTip: false,
      isAuthenticated: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuys'
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuys'
    }
  ],
  '/top-buys-30-days': [
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuys'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'WeeklyTopInsiderBuys'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'WeeklyTopInsiderBuys'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      signInToolTip: false,
      isAuthenticated: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuys'
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuys'
    }
  ],
  '/weekly-top-insider-buy/:date': [
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuyByDate'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'WeeklyTopInsiderBuyByDate'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'WeeklyTopInsiderBuyByDate'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      signInToolTip: false,
      isAuthenticated: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuyByDate'
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuyByDate'
    }
  ],
  '/how-it-works': [
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuyByDate'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'WeeklyTopInsiderBuyByDate'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'WeeklyTopInsiderBuyByDate'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      isAuthenticated: false,
      signInToolTip: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuyByDate'
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      menuItemOnClick: () => {},
      screenName: 'WeeklyTopInsiderBuyByDate'
    }
  ],
  '/pricing': [
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'Pricing'
    },
    // {
    //   title: 'Email Alerts',
    //   icon: <Icon icon={homeFill} {...ICON_SIZE} />,
    //   path: '/email-preference',
    //   isAuthenticated: true,
    //   menuItemOnClick: () => {}
    // },
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'Pricing'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'Pricing'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'Pricing'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      isAuthenticated: false,
      signInToolTip: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      menuItemOnClick: () => {},
      screenName: 'Pricing'
    }
  ],
  '/myaccount': [
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'MyAccount'
    },
    // {
    //   title: 'Email Alerts',
    //   icon: <Icon icon={homeFill} {...ICON_SIZE} />,
    //   path: '/email-preference',
    //   isAuthenticated: true,
    //   menuItemOnClick: () => {}
    // },
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'MyAccount'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'MyAccount'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'MyAccount'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      isAuthenticated: false,
      signInToolTip: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      menuItemOnClick: () => {},
      screenName: 'MyAccount'
    }
  ],
  '/insidertrading/activities': [
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'InsiderTradingActivities'
    },
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'InsiderTradingActivities'
    },
    // {
    //   title: 'Email Alerts',
    //   icon: <Icon icon={homeFill} {...ICON_SIZE} />,
    //   path: '/email-preference',
    //   isAuthenticated: true,
    //   menuItemOnClick: () => {}
    // },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'InsiderTradingActivities'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'InsiderTradingActivities'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      isAuthenticated: false,
      signInToolTip: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Sign out',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/insidertrading/activities',
      isAuthenticated: true,
      redirectURL: '/insidertrading/activities',
      menuItemOnClick: () => {}
    }
  ],
  '/insidertrading/traders': [
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'InsiderTraders'
    },
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'InsiderTraders'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'InsiderTraders'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'InsiderTraders'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      isAuthenticated: false,
      signInToolTip: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Sign out',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/insidertrading/traders',
      isAuthenticated: true,
      redirectURL: '/insidertrading/traders',
      menuItemOnClick: () => {}
    }
  ],
  '/insidertrading/profile/:insiderId': [
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'InsiderTradersProfile'
    },
    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'InsiderTradersProfile'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'InsiderTradersProfile'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'InsiderTradersProfile'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'API',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/real-time-api',
      signInToolTip: false,
      isAuthenticated: false,
      menuItemOnClick: () => {}
    },
    {
      title: 'Sign out',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/insidertrading/profile/:insiderId',
      isAuthenticated: true,
      redirectURL: '/insidertrading/profile/:insiderId',
      menuItemOnClick: () => {}
    }
  ],
  '/insidertrading/promotion': [
    {
      title: 'Sign in',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: PATH_AUTH.login,
      isAuthenticated: undefined,
      redirectURL: '/insidertrading'
    },
    {
      title: 'Sign out',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/insidertrading/promotion',
      isAuthenticated: true,
      redirectURL: '/insidertrading/promotion',
      menuItemOnClick: () => {}
    }
  ],
  '/insidertrading/algo_trading_showcase': [
    {
      title: 'Sign in',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: PATH_AUTH.login,
      isAuthenticated: undefined,
      redirectURL: '/insidertrading'
    },
    {
      title: 'Sign out',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/insidertrading/promotion',
      isAuthenticated: true,
      redirectURL: '/insidertrading/promotion',
      menuItemOnClick: () => {}
    }
  ],
  '/real-time-api': [
    {
      title: 'Pricing',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/pricing',
      isAuthenticated: undefined,
      menuItemOnClick: () => {},
      screenName: 'RealTimeAPI'
    },

    {
      title: 'Weekly Tops',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/weekly-top-insider-buys',
      isAuthenticated: undefined,
      signInToolTip: false,
      menuItemOnClick: () => {},
      screenName: 'RealTimeAPI'
    },
    {
      title: 'Premium',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '',
      isAuthenticated: undefined,
      childItems: [
        {
          title: 'Daily Top Insider Buys',
          path: '/daily-top-insider-buys',
          screenName: 'RealTimeAPI'
        },
        {
          title: 'Top Buys in the Past 30 Days',
          path: '/top-buys-30-days',
          screenName: 'RealTimeAPI'
        }
      ],
      menuItemOnClick: () => {}
    },
    {
      title: 'Sign out',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/insidertrading',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      menuItemOnClick: () => {}
    },
    {
      title: 'My Account',
      icon: <Icon icon={homeFill} {...ICON_SIZE} />,
      path: '/myaccount',
      isAuthenticated: true,
      redirectURL: '/insidertrading',
      menuItemOnClick: () => {},
      screenName: 'RealTimeAPI'
    }
  ]
};

export default menuConfig;
